import { useParams } from "react-router";
import { Confirmation } from "@/services/backend/vbs/confirmations/types/confirmation";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useVbsConfirmationShowQuery } from "@/services/backend/vbs/confirmations/api/confirmation-api";
import t from "@/lang/lang";
import { Card } from "@/shared/components/ui/card";
import { ConfirmationDataCard } from "@/services/backend/vbs/confirmations/components/confirmation-data-card";
import { PricingCards } from "@/services/backend/vbs/pricing/components/pricing-cards";
import { PricingByAreaCard } from "@/services/backend/vbs/pricing/components/pricing-by-area-card";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function ConfirmationDataRoute() {
  const { confirmationId } = useParams();

  if (!confirmationId) {
    return null;
  }

  return <ConfirmationData confirmationId={confirmationId} />;
}

function ConfirmationData({ confirmationId }: { confirmationId: string }) {
  const {
    data: confirmation,
    isLoading,
    error,
  } = useVbsConfirmationShowQuery({
    id: confirmationId,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!confirmation) {
    return <div />;
  }

  return <ConfirmationDataView confirmation={confirmation} />;
}

export function ConfirmationDataView({
  confirmation,
}: {
  confirmation: Confirmation;
}) {
  return (
    <div className="space-y-2">
      <ConfirmationDataCard confirmationId={confirmation.id} />
      <PricingCards
        pricingId={confirmation.pricingId}
        disabled={isImmutable(confirmation)}
      />
      <PricingByAreaCard
        pricingByAreaId={confirmation.pricingByAreaId}
        disabled={isImmutable(confirmation)}
      />
      <Textblocks
        subdomain={GSMSubdomain.VBS}
        documentKind={confirmation.documentKind}
        documentId={confirmation.id}
        title={t("Bemerkungen in Auftragsbestätigung")}
        defaultOpen={false}
      />
    </div>
  );
}
